import SidePage from '../../../../../../shared/SidePage'
import SeparateLine from '../../../../../../shared/Forms/SeparateLine'
import useStateWithChange from '../../../../../../shared/hooks/useStateWithChange.ts'
import { TCreateMaintenanceBlankDTO } from '../../../maintenance.types.ts'
import maintenanceBlanksUtils from '../../maintenanceBlanks.utils.ts'
import Button from '../../../../../../shared/Buttons/Button'
import useHttpLoader from '../../../../../../shared/hooks/useHttpLoader.ts'
import maintenanceApi from '../../../maintenance.api.ts'
import maintenanceEvents from '../../../events/maintenance.events.ts'
import useNestedArrayChangeCallbacks from '@/shared/hooks/useNestedArrayChangeCallbacks.ts'
import MaintenanceBlankForm from '@/pages/Processes/Maintenance/MaintenanceBlanks/components/MaintenanceBlankForm'

interface IProps {
  onClose: () => void
  open: boolean
}

const CreateBlankSidePage = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [blank, setBlank, handleChange] = useStateWithChange<TCreateMaintenanceBlankDTO>(
    maintenanceBlanksUtils.generateCreateBlankDTO()
  )

  const {
    handleCreateNewElement: handleFieldCreate,
    handleElementUpdate: handleFieldUpdate,
    handleElementDelete: handleFieldDelete,
  } = useNestedArrayChangeCallbacks({
    sourceObjectSetter: setBlank,
    nestedArrayKey: 'fields',
    newEntityGenerator: () => maintenanceBlanksUtils.generateBlankFieldDTO(blank.fields.length),
  })

  const handleSave = () => {
    wait(maintenanceApi.createBlankSchema(blank), (resp) => {
      if (resp.status === 'success') {
        maintenanceEvents.schemaCreated(resp.body)
        props.onClose()
      }
    })
  }

  return (
    <SidePage onClose={props.onClose} open={props.open} style={{ paddingBottom: 0, paddingRight: 0 }} size="large">
      <div className="flex-lines gap16" style={{ height: '100%' }}>
        <h2 className="text-heading-4">Создание бланка ТО</h2>
        <div style={{ paddingRight: '20px' }}>
          <SeparateLine />
        </div>
        <div className="flex-lines gap16" style={{ minHeight: 0, overflow: 'auto', paddingRight: '20px' }}>
          <MaintenanceBlankForm
            blank={blank}
            onChange={handleChange}
            onCreateField={handleFieldCreate}
            onDeleteField={handleFieldDelete}
            onUpdateField={handleFieldUpdate}
          />
        </div>
        <div style={{ marginTop: 'auto', paddingRight: '20px' }}>
          <SeparateLine />
        </div>
        <div className="inline-flex-gap gap8" style={{ paddingBottom: '20px' }}>
          <Button size="default" type="primary" text="Создать" onClick={handleSave} loading={loading} />
          <Button size="default" type="default" text="Отменить" onClick={props.onClose} disabled={loading} />
        </div>
      </div>
    </SidePage>
  )
}

export default CreateBlankSidePage
